
export const NotificationStatuses = {
  READ: "R",// Seen AND Clicked
  SEEN: "S",// Seen but not clicked
  NEW: "N",
} as const;
